import { useNavigate } from "react-router-dom";
import { getIcon } from "../lib/icons";

export const CategoryCard = ({ category, index = 0 }) => {
  const navigate = useNavigate();
  const Icon = getIcon(category.icon);

  return (
    <button
      onClick={() => navigate(`/categories/${category.slug}`)}
      className="group bg-white rounded-2xl p-6 border border-transparent hover:border-gray-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] hover:-translate-y-1 transition-all duration-300 flex flex-col items-center text-center animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 10) * 50}ms` }}
      data-testid={`category-card-${category.slug}`}
    >
      <div
        className="w-16 h-16 rounded-2xl flex items-center justify-center mb-4 transition-transform duration-300 group-hover:scale-110"
        style={{ backgroundColor: `${category.color}18`, color: category.color }}
      >
        <Icon size={28} strokeWidth={1.75} />
      </div>
      <h3 className="font-display font-semibold text-[#0F0F0F] text-base leading-snug mb-1">
        {category.name}
      </h3>
      <p className="text-xs text-[#687280]">{category.count > 0 ? `${category.count} Ideas` : "Coming soon"}</p>
    </button>
  );
};
